import React from "react"
import { Header } from "src/components/layout/header"
import { DebtsTab } from "src/pages-lib/bonus-points/debts-tab"

// Минусовые балансы после списания за технический сбой: долг, погашение, прогноз.
export default function BonusPointsDebts() {
  return (
    <>
      <Header title="Баллы: минусовые балансы" />
      <DebtsTab />
    </>
  )
}
